import {
  ClipboardCheck,
  Database,
  BarChart3, Bell, Workflow, Gauge, Siren, Building2, Contact, Eye, FlaskConical, Trash, User, UserX, Globe, CalendarDays, CalendarOff, Clock, FolderTree, Inbox, LayoutDashboard, ListChecks,
  Mail, MessageSquareText, PhoneMissed, PhoneCall, Truck, ShoppingBag, Activity, Archive, ShieldOff, Search, Palette, ScrollText, Settings, ShieldCheck, Users, UsersRound,
} from "lucide-react";

const ADMIN = ["admin"];

export const NAV_SECTIONS = [
  {
    id: "overview",
    label: "Overview",
    items: [
      { id: "cockpit", to: "/cockpit", label: "Cockpit", icon: Gauge },
      { id: "dashboard", to: "/dashboard", label: "System dashboard", icon: LayoutDashboard, roles: ADMIN },
      { id: "notifications", to: "/notifications", label: "Notifications", icon: Bell },
      { id: "reports", to: "/reports", label: "Reports", icon: BarChart3, roles: ["admin", "manager", "readonly"] },
    ],
  },
  {
    id: "tickets",
    label: "Tickets",
    items: [
      { id: "tickets-attention", to: "/tickets?view=attention", label: "Attention", icon: Siren, badge: "attention" },
      { id: "tickets-needs-brand", to: "/tickets?view=needs_brand", label: "Needs brand", icon: Truck, roles: ["admin", "manager"], badge: "needs_brand" },
      { id: "tickets-mine", to: "/tickets?view=mine", label: "My tickets", icon: User },
      { id: "tickets-unassigned", to: "/tickets?view=unassigned", label: "Unassigned", icon: UserX, badge: "unassigned" },
      { id: "tickets-team", to: "/tickets?view=team", label: "Team queues", icon: UsersRound },
      { id: "tickets-watching", to: "/tickets?view=watching", label: "Watching", icon: Eye },
      { id: "tickets-all", to: "/tickets?view=all", label: "All tickets", icon: Globe },
      { id: "tickets-junk", to: "/tickets?view=junk", label: "Junk review", icon: Trash, roles: ADMIN },
      { id: "unlogged-calls", to: "/calls/unlogged", label: "Unlogged calls", icon: PhoneMissed, badge: "unlogged" },
      { id: "contacts", to: "/contacts", label: "Contacts", icon: Contact },
      { id: "suppliers", to: "/suppliers", label: "Suppliers", icon: Truck },
      { id: "search", to: "/search", label: "Search", icon: Search },
      { id: "templates", to: "/templates", label: "Canned replies", icon: MessageSquareText, roles: ["admin", "manager", "agent"] },
    ],
  },
  {
    id: "hours",
    label: "Business hours",
    items: [
      { id: "calendar", to: "/calendar", label: "Calendar", icon: CalendarDays },
      { id: "base-hours", to: "/admin/base-hours", label: "Base hours", icon: Clock, roles: ADMIN },
      { id: "bank-holidays", to: "/admin/bank-holidays", label: "Bank holidays", icon: CalendarOff, roles: ADMIN },
    ],
  },
  {
    id: "admin",
    label: "Administration",
    items: [
      { id: "users", to: "/admin/users", label: "Users", icon: Users, roles: ADMIN },
      { id: "teams", to: "/admin/teams", label: "Teams", icon: UsersRound, roles: ADMIN },
      { id: "roles", to: "/admin/roles", label: "Roles & permissions", icon: ShieldCheck, roles: ADMIN },
      { id: "brands", to: "/admin/brands", label: "Brands", icon: Building2, roles: ADMIN },
      { id: "mailboxes", to: "/admin/mailboxes", label: "Mailboxes", icon: Inbox, roles: ADMIN },
      { id: "email-templates", to: "/admin/email-templates", label: "Email templates", icon: Mail, roles: ["admin", "manager"] },
      { id: "rules", to: "/settings/rules", label: "Rules", icon: Workflow, roles: ["admin", "manager"] },
      { id: "email-simulator", to: "/admin/email-simulator", label: "Email simulator", icon: FlaskConical, roles: ADMIN, previewOnly: true },
      { id: "phone-simulator", to: "/admin/phone-simulator", label: "Phone simulator", icon: PhoneCall, roles: ADMIN, previewOnly: true },
      { id: "magento-orders", to: "/admin/magento-orders", label: "Magento orders", icon: ShoppingBag, roles: ADMIN },
      { id: "statuses", to: "/admin/statuses", label: "Statuses", icon: ListChecks, roles: ADMIN },
      { id: "categories", to: "/admin/categories", label: "Categories & priorities", icon: FolderTree, roles: ADMIN },
    ],
  },
  {
    id: "system",
    label: "System",
    items: [
      { id: "readiness", to: "/admin/readiness", label: "Go-live readiness", icon: ClipboardCheck, roles: ADMIN, previewOnly: true },
      { id: "test-data", to: "/admin/test-data", label: "Test data", icon: Database, roles: ADMIN, previewOnly: true },
      { id: "health", to: "/admin/health", label: "Integration health", icon: Activity, roles: ADMIN },
      { id: "retention", to: "/admin/retention", label: "Retention", icon: Archive, roles: ADMIN },
      { id: "gdpr", to: "/admin/gdpr", label: "GDPR tools", icon: ShieldOff, roles: ADMIN },
      { id: "audit", to: "/admin/audit", label: "Audit log", icon: ScrollText, roles: ADMIN },
      { id: "outbox", to: "/admin/outbox", label: "Sent email log", icon: Mail, roles: ADMIN },
      { id: "app-styling", to: "/settings/app-styling", label: "App styling", icon: Palette, roles: ADMIN },
      { id: "settings", to: "/settings", label: "Settings", icon: Settings, roles: ADMIN },
    ],
  },
];
